import FloatThead from './components/FloatThead.vue'

function install(Vue, options) {
   Vue.component('FloatTheadTable', FloatThead);
}

export default install;



// WEBPACK FOOTER //
// ./src/main.js